import { render, staticRenderFns } from "./filterTips.vue?vue&type=template&id=426da826&"
import script from "./filterTips.vue?vue&type=script&lang=js&"
export * from "./filterTips.vue?vue&type=script&lang=js&"
import style0 from "./filterTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports